/**
 * Base URL for public marketing/API calls from the browser.
 * Uses REACT_APP_BACKEND_URL when set; otherwise same-origin (e.g. API behind reverse proxy on the site host).
 */
export function getPublicApiBaseUrl() {
  const raw = process.env.REACT_APP_BACKEND_URL;
  if (raw != null && String(raw).trim() !== '') {
    return String(raw).replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return String(window.location.origin).replace(/\/+$/, '');
  }
  return '';
}
